import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Divider, Stack, Typography } from "@mui/material";
import { KeyboardArrowDown, Edit } from "@mui/icons-material";

import { CardLayout, IconButton } from "../v3";
import { UpdateStatus } from ".";
import { get_date } from "../generalComponets";
import { useHasPermission } from "../../utils";
import { EDIT_PROJECT } from "../../constants";

export const ProjectDetails = ({ projectDetails = {}, reloadData = () => {} }) => {
  const [openModal, setOpenModal] = useState(false);

  const { id } = useParams();
  const navigate = useNavigate();

  const hasEditProject = useHasPermission(EDIT_PROJECT);

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleEditProject = () => {
    navigate(`/projects/edit/${id}`);
  };

  const getProjectStatus = (status) => {
    switch (status) {
      case "TODO":
        return { label: "To Do", color: "#f44336", backgroundColor: "#FFE6E6" };
      case "INPROGRESS":
        return { label: "In Progress", color: "#674BF5", backgroundColor: "#ecddfdff" };
      case "DONE":
        return { label: "Completed", color: "#4caf50", backgroundColor: "#E6FFE6" };
      default:
        return { label: "Status", color: "#919191", backgroundColor: "#F2F2F2" };
    }
  };

  const { label, color, backgroundColor } = getProjectStatus(projectDetails?.status);

  const detailRows = [
    {
      leftLabel: "Estimated Amount",
      leftValue: projectDetails?.estimatedAmount ? `₹${projectDetails.estimatedAmount}` : "Not Provided",
      rightLabel: "Project Type",
      rightValue: (
        <Typography variant="body2" sx={{ color: "#7C4DFF", fontWeight: 500 }}>
          {projectDetails?.type}
        </Typography>
      ),
    },
    {
      leftLabel: "Start Date",
      leftValue: get_date(projectDetails?.expectedStartDate),
      rightLabel: "End Date",
      rightValue:
        projectDetails?.status === "DONE" ? get_date(projectDetails?.endDate) : get_date(projectDetails?.expectedEndDate),
    },
  ];

  return (
    <>
      <CardLayout sx={{ margin: "11px" }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: 600, color: "#674BF5" }}>
            Project Details
          </Typography>

          <Box sx={{ display: "flex", gap: 1 }}>
            {hasEditProject && (
              <>
                {/* status button */}
                <IconButton
                  icon={<KeyboardArrowDown />}
                  iconPosition="end"
                  buttonText={label}
                  tooltip="Update Status"
                  onClick={handleOpenModal}
                  styles={{ fontWeight: 600, letterSpacing: "0.5px", color: color, backgroundColor: backgroundColor }}
                  hoverStyles={{ backgroundColor: "#F2F2F2" }}
                />
                {/* edit icon */}
                <IconButton
                  icon={<Edit />}
                  tooltip="Edit"
                  onClick={handleEditProject}
                  styles={{ color: "#919191", backgroundColor: "#F2F2F2" }}
                  hoverStyles={{ backgroundColor: "#ecddfdff" }}
                />
              </>
            )}
          </Box>
        </Box>

        <Stack spacing={2}>
          {/* project name */}
          <Box>
            <Typography variant="caption">Project Name</Typography>
            <Typography variant="body2" sx={{ fontWeight: 500, textTransform: "uppercase" }}>
              {projectDetails?.name}
            </Typography>
          </Box>

          {/* details reusable row */}
          {detailRows.map((row, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                gap: 2,
              }}
            >
              <Box sx={{ flex: "1 1 45%" }}>
                <Typography variant="caption">{row.leftLabel}</Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {row.leftValue}
                </Typography>
              </Box>

              <Divider orientation="vertical" flexItem sx={{ height: 35, alignSelf: "center" }} />

              <Box sx={{ flex: "1 1 45%" }}>
                <Typography variant="caption">{row.rightLabel}</Typography>
                <Typography variant="body2" sx={{ fontWeight: 500 }}>
                  {row.rightValue}
                </Typography>
              </Box>
            </Box>
          ))}

          {/* description */}
          <Box>
            <Typography variant="caption">Description</Typography>
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              {projectDetails?.description || "Not Provided"}
            </Typography>
          </Box>
        </Stack>
      </CardLayout>

      {/* update status modal */}
      <UpdateStatus
        open={openModal}
        onClose={handleCloseModal}
        currentStatus={projectDetails?.status}
        currentEndDate={projectDetails?.endDate}
        onSuccess={reloadData}
      />
    </>
  );
};
